import { QueryClient, isServer } from "@tanstack/react-query";

const ONE_MINUTE = 60_000;

export const queryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: ONE_MINUTE,
    },
  },
};

let browserQueryClient: QueryClient | undefined;

export const getQueryClient = () => {
  if (isServer) {
    return new QueryClient(queryClientConfig);
  }
  browserQueryClient ??= new QueryClient(queryClientConfig);
  return browserQueryClient;
};
